import { createContext, useContext, useEffect, useMemo, useState } from "react";
import spanish from "../language/esp";
import english from "../language/eng";
import french from "../language/fra";
import japanese from "../language/jap";

const LocaleContext = createContext(null);

function detectDeviceLocale() {
  const supported = {
    es: "ES",
    en: "EN",
    fr: "FR",
    ja: "JA",
  };
  const languages = Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages
    : [navigator.language];

  for (const language of languages) {
    const base = String(language || "").toLowerCase().split("-")[0];
    if (supported[base]) return supported[base];
  }
  return "ES";
}

const translations = {
  ES: spanish,
  EN: english,
  FR: french,
  JA: japanese,
};

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(
    () => localStorage.getItem("userPreferedLanguage") || detectDeviceLocale(),
  );
  const setLocale = (next) => {
    localStorage.setItem("userPreferedLanguage", next);
    document.documentElement.lang = next.toLowerCase();
    setLocaleState(next);
  };
  useEffect(() => {
    document.documentElement.lang = locale.toLowerCase();
    const syncLocale = (event) => {
      if (event.key !== "userPreferedLanguage" || !event.newValue) return;
      setLocaleState(event.newValue);
    };
    window.addEventListener("storage", syncLocale);
    return () => window.removeEventListener("storage", syncLocale);
  }, [locale]);
  const value = useMemo(
    () => ({ locale, setLocale, t: (key) => translations[locale]?.[key] || translations.ES[key] || key }),
    [locale],
  );
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  return useContext(LocaleContext);
}
